import { useRef, useState } from "react";
import { ConvertMonthTHFull } from "../../widgets/form/ConvertTime";
import Icon from "../Icon";
import {
  DOCUMENT_SAVE_MESSAGES,
  PDF_MIME_TYPE,
  fetchPdfFile,
  openInExternalBrowser,
  saveFile,
  toPdfFileName,
} from "../../utils/documentDownload";
import type { DownloadDocumentType } from "../../utils/documentDownload";

const DetailModal = ({ data, registration, historyData }: any) => {
  return (
    <>
      <div style={{ fontFamily: 'Google Sans, sans-serif' }}>
        {/* Name and Address
        <div className="row mb-3">
          <div className="col-12 col-md-6 mb-2 mb-md-0">
            <div className="mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>ชื่อผู้ใช้น้ำ</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C', fontWeight: '500' }}>
              {registration?.name || "-"}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>ที่อยู่</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {registration?.address || "-"}
            </div>
          </div>
        </div>


        <div className="row mb-3">
          <div className="col-12 col-md-6 mb-2 mb-md-0">
            <div className="mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>ทะเบียนผู้ใช้น้ำ</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {registration?.registrationNumber || "-"}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>หมายเลขมาตร</div>
            <div style={{ fontSize: '16px', color: '#4263B5', fontWeight: '500' }}>
              {registration?.meterNumber || "-"}
            </div>
          </div>
        </div> */}


        {/* <hr className="my-3" /> */}

        {/* Additional Details */}
        <div className="row mb-3">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="" style={{ fontSize: '14px', opacity: '0.5' }}>รอบบิล</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {data?.month ? ConvertMonthTHFull(data.month) : "-"}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="" style={{ fontSize: '14px', opacity: '0.5' }}>วันที่ชำระ</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {data?.paymentDate && data.paymentDate !== "-" ? data.paymentDate : <span className="text-danger bg-danger-subtle p-1 px-2 rounded-2">ยังไม่ได้ชำระ</span>}
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="" style={{ fontSize: '14px', opacity: '0.5' }}>หน่วยที่ใช้</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {data?.units || 0} หน่วย
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="" style={{ fontSize: '14px', opacity: '0.5' }}>ยอดชำระ</div>
            <div style={{ fontSize: '16px', color: '#2C2C2C' }}>
              {data?.amount || 0} บาท
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Export footer component separately
export const DetailModalFooter = ({ data, isMobile }: any) => {
  const [downloadingType, setDownloadingType] = useState<DownloadDocumentType | null>(null);
  const [notice, setNotice] = useState('');
  // Fetched PDFs by stream URL: when iOS refuses to open the share sheet after a
  // slow fetch, the next tap shares the file straight away.
  const fetchedFiles = useRef<Record<string, File | undefined>>({});

  const handleDownload = async (downloadType: DownloadDocumentType) => {
    const isReceipt = downloadType === 'receipt';
    const streamUrl = isReceipt ? data?.receiptStreamUrl : data?.invoiceStreamUrl;
    if (downloadingType || !streamUrl) return;

    const fileName = toPdfFileName(isReceipt ? data?.receiptFileName : data?.invoiceFileName, downloadType);

    setDownloadingType(downloadType);
    setNotice('');
    try {
      const outcome = await saveFile({
        fileName,
        mimeType: PDF_MIME_TYPE,
        getFile: () => fetchedFiles.current[streamUrl] ?? fetchPdfFile(streamUrl, fileName).then(file => {
          fetchedFiles.current[streamUrl] = file;
          return file;
        }),
        openExternal: () => openInExternalBrowser('document', {
          _dl: downloadType,
          _name: fileName,
          _url: streamUrl,
        }),
      });
      setNotice(DOCUMENT_SAVE_MESSAGES[outcome]);
    } catch (error) {
      console.error(`Error downloading ${downloadType}:`, error);
      setNotice('ดาวน์โหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง');
    } finally {
      setDownloadingType(null);
    }
  };

  if (!data?.receiptStreamUrl && !data?.invoiceStreamUrl) {
    return null;
  }

  const isDownloadingReceipt = downloadingType === 'receipt';
  const isDownloadingInvoice = downloadingType === 'invoice';

  return (
    <div style={{
      padding: '16px 0px 0px 0px',
      borderTop: '1px solid #E0E0E0',
      backgroundColor: '#FFFFFF',
      position: 'sticky',
      bottom: 0,
      zIndex: 10
    }}>
      <div className="d-flex gap-2 w-fit justify-content-center">
        {data?.receiptStreamUrl && (
          <button
            onClick={() => handleDownload('receipt')}
            disabled={downloadingType !== null}
            style={{
              backgroundColor: '#4263B5',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '14px',
              cursor: isDownloadingReceipt ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontFamily: 'Google Sans, sans-serif',
              fontWeight: '500',
              width: '100%',
              margin: '0 auto',
              opacity: isDownloadingReceipt ? 0.7 : 1
            }}
            title="ดาวน์โหลดใบเสร็จ"
          >
            {isDownloadingReceipt ? (
              <Icon icon="spinner" spin style={{ fontSize: '14px' }} />
            ) : (
              <Icon icon="download" style={{ fontSize: '14px' }} />
            )}
            <span style={{ fontSize: isMobile ? '10px' : '14px' }}>
              {isDownloadingReceipt ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดใบเสร็จ'}
            </span>
          </button>
        )}
        {data?.invoiceStreamUrl && (
          <button
            onClick={() => handleDownload('invoice')}
            disabled={downloadingType !== null}
            style={{
              backgroundColor: '#f8f9ff',
              color: '#4263B5',
              border: '1px solid #4263B5',
              borderRadius: '8px',
              padding: '8px 16px',
              fontSize: '14px',
              cursor: isDownloadingInvoice ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontFamily: 'Google Sans, sans-serif',
              fontWeight: '500',
              width: '100%',
              margin: '0 auto',
              opacity: isDownloadingInvoice ? 0.7 : 1
            }}
            title="ดาวน์โหลดใบแจ้งหนี้"
          >
            {isDownloadingInvoice ? (
              <Icon icon="spinner" spin style={{ fontSize: '14px' }} />
            ) : (
              <Icon icon="download" style={{ fontSize: '14px' }} />
            )}
            <span style={{ fontSize: isMobile ? '10px' : '14px' }}>
              {isDownloadingInvoice ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดใบแจ้งหนี้'}
            </span>
          </button>
        )}
      </div>
      {notice ? (
        <div style={{ marginTop: '8px', fontSize: '12px', color: '#6F6B7D', textAlign: 'center', fontFamily: 'Google Sans, sans-serif' }}>
          {notice}
        </div>
      ) : null}
    </div>
  );
};

export { DetailModal };
